import { render, staticRenderFns } from "./NmicHomePage.vue?vue&type=template&id=f70401b6&scoped=true&"
import script from "./NmicHomePage.vue?vue&type=script&lang=js&"
export * from "./NmicHomePage.vue?vue&type=script&lang=js&"
import style0 from "./NmicHomePage.vue?vue&type=style&index=0&id=f70401b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70401b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
